<template>
  <div class="gf-field">
    <textarea v-model="componentValue" :placeholder="placeholder"></textarea>
  </div>
</template>

<script>
import { componentMixin } from './FormCommon'

export default {
  props: ["placeholder"],
  mixins: [componentMixin],
}
</script>
